module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "carousel",
    staticClass: "product-carousel-wrapper no-article-gutter-mobile no-article-swipe"
  }, [(_vm.products) ? _c('div', {
    staticClass: "product-carousel-horizontal-line no-mobile-article-gutter"
  }) : _vm._e(), _c('div', {
    staticClass: "product-carousel"
  }, _vm._l((_vm.products), function(product, index) {
    return (product) ? _c('a', {
      staticClass: "product-carousel-item",
      attrs: {
        "href": ("#product-" + index)
      }
    }, [_c('div', {
      staticClass: "product-carousel-item-circle-border"
    }, [_c('img', {
      directives: [{
        name: "image-orientation",
        rawName: "v-image-orientation"
      }, {
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.image(product)),
        expression: "image(product)"
      }]
    })]), _c('span', {
      staticClass: "product-carousel-item-title"
    }, [_vm._v(_vm._s(product.product.title))])]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011d0170","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/comparison/ComparisonProductCarousel.vue
// module id = 1721
// module chunks = 25